// extracted by mini-css-extract-plugin
module.exports = {"logout":"MainLayout_logout__JROqZ"};